module.exports = __webpack_public_path__ + "img/phone.c20ea7f0.png";